export const COPY_URL_KEY = 'copyUrl'
export const TWITTER_ACCOUNT = 'BobtailYearling'
